<template>
  <v-tooltip
    v-if="menuItems.length > 0"
    right
    :disabled="!miniVariant"
    open-delay="270"
  >
    <template #activator="{ on, attrs }">
      <v-list-group
        v-model="group"
        v-bind="attrs"
        no-action
        class="d-menu"
        v-on="on"
        @click="clicked"
      >
        <template #activator>
          <v-list-item-action @click="clicked">
            <v-icon>{{ group && filledIcon ? filledIcon : icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content @click="clicked">
            <v-list-item-title>{{ title }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <template v-for="(item, i) in menuItems">
          <g-menu-item
            :key="`menu_group_${i}`"
            :title="item.text"
            :to="item.link"
            :disabled="!item.link"
            :label-badge="item.labelBadge"
            link
          />
        </template>
      </v-list-group>
    </template>
    <span>{{ title }}</span>
  </v-tooltip>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import { MenuItem } from '@/util/menu';
import GMenuItem from '@/components/util/MenuItem.vue';
import { TranslateResult } from 'vue-i18n';

const props = defineProps({
  miniVariant: { type: Boolean, required: false, default: false },
  menuItems: { type: Array as PropType<Array<MenuItem>>, required: false, default: () => [] },
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
  icon: { type: String, required: true },
  filledIcon: { type: String, required: false, default: undefined },
});

const emit = defineEmits(['menu-expand']);

const group = ref(false);

const clicked = () => emit('menu-expand');

</script>
